import React from "react"
import hasCSSGridSupport from "@secureo/common/utils/detection/hasCSSGridSupport"

const NoCSSGridSupportWarning = () => {
	if (hasCSSGridSupport()) return null

	return (
		<div style={{ backgroundColor: "papayawhip", padding: "2rem" }}>
			Um den Konfigurator zu verwenden, müssen Sie{" "}
			<a
				href="https://developer.mozilla.org/de/docs/Web/CSS/grid#Browserkompatibilit%C3%A4t"
				target="__blank"
			>
				einen modernen Browser
			</a>{" "}
			verwenden.
		</div>
	)
}

export default NoCSSGridSupportWarning
